// Predefined specialities with their descriptions
// This data is used to display detailed information about hospital specialities

export const specialitiesData = {
  'Urology': {
    title: 'Urology',
    description: 'Comprehensive care for urinary tract disorders, kidney diseases, and male reproductive health conditions with advanced minimally invasive procedures.'
  },
  'Cardiac Sciences': {
    title: 'Cardiac Sciences', 
    description: 'Leading-edge cardiac care including interventional cardiology, cardiac surgery, and heart transplantation with state-of-the-art technology.'
  },
  'Nephrology': {
    title: 'Nephrology',
    description: 'The Department of Nephrology stands as a leader in kidney care and renal expertise, addressing a wide range of kidney-related conditions.'
  },
  'Cardiology': {
    title: 'Cardiology',
    description: 'Advanced heart care services including diagnosis and treatment of cardiovascular diseases, preventive cardiology, and cardiac rehabilitation.'
  },
  'Oncology': {
    title: 'Oncology',
    description: 'Offers premier oncological care, providing specialized treatments for all types of cancer with multidisciplinary approach.'
  },
  'Neurology': {
    title: 'Neurology',
    description: 'Comprehensive neurological care for brain, spinal cord, and nervous system disorders with cutting-edge diagnostic and treatment facilities.'
  },
  'Neurosciences': {
    title: 'Neurosciences',
    description: 'The Department of Neurosciences is renowned for its exceptional clinical care and cutting-edge infrastructure, specializing in the treatment of a wide range of neurological and spinal conditions.'
  },
  'Orthopaedics': {
    title: 'Orthopaedics',
    description: 'Expert care for bone, joint, and musculoskeletal disorders including joint replacement, sports medicine, and trauma surgery.'
  },
  'Gastroenterology': {
    title: 'Gastroenterology',
    description: 'Specialized treatment for digestive system disorders, liver diseases, and gastrointestinal conditions with advanced endoscopic procedures.'
  },
  'Dermatology': {
    title: 'Dermatology',
    description: 'Comprehensive skin care services including medical dermatology, cosmetic procedures, and treatment of skin cancers.'
  },
  'ENT (Ear, Nose, Throat)': {
    title: 'ENT (Ear, Nose, Throat)',
    description: 'Expert care for ear, nose, throat, and head & neck disorders with advanced surgical and non-surgical treatment options.'
  },
  'Ophthalmology': {
    title: 'Ophthalmology',
    description: 'Complete eye care services including cataract surgery, retinal treatments, and corneal transplantation with latest technology.'
  },
  'Gynecology': {
    title: 'Gynecology',
    description: 'Comprehensive women\'s health services including obstetrics, gynecological surgery, and reproductive medicine.'
  },
  'Pediatrics': {
    title: 'Pediatrics',
    description: 'Specialized medical care for infants, children, and adolescents with dedicated pediatric ICU and emergency services.'
  },
  'Internal Medicine': {
    title: 'Internal Medicine',
    description: 'Comprehensive medical care for adult patients with focus on prevention, diagnosis, and treatment of internal diseases.'
  },
  'Emergency Medicine': {
    title: 'Emergency Medicine',
    description: '24/7 emergency care with trauma center, critical care facilities, and immediate medical response for all emergencies.'
  },
  'Radiology': {
    title: 'Radiology',
    description: 'Advanced imaging services including MRI, CT, PET scans, and interventional radiology with digital technology.'
  },
  'Anesthesiology': {
    title: 'Anesthesiology',
    description: 'Expert anesthesia and pain management services for surgical procedures and chronic pain conditions.'
  },
  'Pathology': {
    title: 'Pathology',
    description: 'Comprehensive laboratory services including clinical pathology, histopathology, and molecular diagnostics.'
  },
  'Psychiatry': {
    title: 'Psychiatry',
    description: 'Mental health services including diagnosis and treatment of psychiatric disorders, counseling, and rehabilitation.'
  },
  'General Surgery': {
    title: 'General Surgery',
    description: 'Wide range of surgical procedures including laparoscopic surgery, trauma surgery, and emergency surgical care.'
  },
  'Plastic Surgery': {
    title: 'Plastic Surgery',
    description: 'Reconstructive and cosmetic surgery services including burn care, aesthetic procedures, and microsurgery.'
  },
  'Neurosurgery': {
    title: 'Neurosurgery',
    description: 'Advanced brain and spine surgery including tumor removal, deep brain stimulation, and minimally invasive procedures.'
  },
  'Cardiac Surgery': {
    title: 'Cardiac Surgery',
    description: 'Complex heart surgeries including bypass surgery, valve replacement, and pediatric cardiac procedures.'
  },
  'Vascular Surgery': {
    title: 'Vascular Surgery',
    description: 'Treatment of blood vessel disorders including aneurysms, varicose veins, and peripheral arterial disease.'
  },
  'Spine Surgery': {
    title: 'Spine Surgery',
    description: 'Specialized spinal treatments including minimally invasive spine surgery, disc replacement, and spinal fusion.'
  },
  'Joint Replacement': {
    title: 'Joint Replacement',
    description: 'Advanced joint replacement procedures including knee, hip, and shoulder replacement with robotic assistance.'
  },
  'Robotic Surgery': {
    title: 'Robotic Surgery',
    description: 'Minimally invasive robotic surgical procedures with enhanced precision and faster recovery times.'
  },
  'Transplant Surgery': {
    title: 'Transplant Surgery',
    description: 'Organ transplantation services including liver, kidney, heart, and bone marrow transplantation.'
  },
  'IVF & Fertility': {
    title: 'IVF & Fertility',
    description: 'Comprehensive fertility treatments including IVF, ICSI, and reproductive endocrinology services.'
  },
  'Dialysis': {
    title: 'Dialysis',
    description: 'Kidney dialysis services including hemodialysis and peritoneal dialysis with modern equipment.'
  },
  'ICU': {
    title: 'ICU',
    description: 'Advanced intensive care unit with life support systems and round-the-clock monitoring for critically ill patients.'
  },
  'NICU': {
    title: 'NICU',
    description: 'Specialized neonatal intensive care for premature and critically ill newborns with advanced life support.'
  },
  'Emergency Care': {
    title: 'Emergency Care',
    description: '24/7 emergency medical services with trauma care, ambulance services, and immediate medical response.'
  },
  'Rehabilitation': {
    title: 'Rehabilitation',
    description: 'Comprehensive rehabilitation services including physical therapy, occupational therapy, and speech therapy.'
  },
  'Physiotherapy': {
    title: 'Physiotherapy',
    description: 'Expert physiotherapy services for musculoskeletal disorders, sports injuries, and post-surgical rehabilitation.'
  },
  'Self IVF': {
    title: 'Self IVF',
    description: 'Personalized in-vitro fertilization treatment using the patient’s own eggs to enhance conception success with tailored fertility protocols.'
  },
  'IVF with Indian Egg Donor': {
    title: 'IVF with Indian Egg Donor',
    description: 'Specialized fertility program utilizing Indian egg donors, offering hope to intended parents through carefully matched and screened donors.'
  },
  'IVF with Profile Egg Donor': {
    title: 'IVF with Profile Egg Donor',
    description: 'Advanced fertility solutions with well-profiled egg donors, ensuring transparency, high success rates, and individualized care for each couple.'
  },
  'Frozen Embryo Transfer (FET)': {
    title: 'Frozen Embryo Transfer (FET)',
    description: 'Cutting-edge fertility service involving the transfer of previously frozen embryos, optimizing timing and increasing pregnancy success rates.'
  },
  'Cerebral Palsy': {
    title: 'Cerebral Palsy',
    description: 'Multidisciplinary care for children and adults with cerebral palsy, focusing on mobility, speech, and cognitive improvement through tailored therapies.'
  },
  'Sports Medicine': {
    title: 'Sports Medicine',
    description: 'Comprehensive care for sports-related injuries with specialized rehabilitation, performance enhancement, and preventive strategies.'
  },
  'Orthopedic Rehabilitation': {
    title: 'Orthopedic Rehabilitation',
    description: 'Focused rehabilitation services for recovery from orthopedic injuries, surgeries, and musculoskeletal disorders to restore strength and mobility.'
  },
  'Rheumatology': {
    title: 'Rheumatology',
    description: 'Expert diagnosis and treatment of autoimmune and inflammatory diseases including arthritis, lupus, and joint disorders.'
  },
  'Pulmonology': {
    title: 'Pulmonology',
    description: 'Comprehensive respiratory care for lung diseases such as asthma, COPD, tuberculosis, and pulmonary infections with advanced diagnostics.'
  },
  'Liver Disease & Transplantation': {
    title: 'Liver Disease & Transplantation',
    description: 'Specialized treatment for liver disorders and advanced liver transplantation services with a multidisciplinary team approach.'
  },
  'Orthopaedics and Spine Surgery': {
    title: 'Orthopaedics and Spine Surgery',
    description: 'Integrated orthopedic and spinal care offering surgical and non-surgical solutions for bone, joint, and spine-related conditions.'
  },
  'Female Ovarian Reserve Testing': {
    title: 'Female Ovarian Reserve Testing',
    description: 'Accurate assessment of female fertility potential through ovarian reserve tests including AMH, FSH, and antral follicle count.'
  },
  'Intracytoplasmic Sperm Injection (ICSI)': {
    title: 'Intracytoplasmic Sperm Injection (ICSI)',
    description: 'Precision fertility technique involving direct injection of sperm into the egg to improve fertilization in severe male infertility cases.'
  },
  'Pre-Implantation Genetic Screening (PGS) & Diagnosis (PGD)': {
    title: 'Pre-Implantation Genetic Screening (PGS) & Diagnosis (PGD)',
    description: 'Advanced embryo screening technologies to detect genetic abnormalities before implantation, ensuring healthy embryo selection.'
  },
  'Time-Lapse Imaging & Blastocyst Culture': {
    title: 'Time-Lapse Imaging & Blastocyst Culture',
    description: 'Innovative embryo monitoring using time-lapse imaging and extended blastocyst culture to select the best quality embryos for transfer.'
  },
  'Egg, Sperm & Embryo Donation Programs': {
    title: 'Egg, Sperm & Embryo Donation Programs',
    description: 'Comprehensive third-party reproduction services providing screened donors and advanced techniques for successful conception.'
  },
  'Genetic Testing & Counseling': {
    title: 'Genetic Testing & Counseling',
    description: 'Personalized genetic evaluations and counseling services for inherited conditions, reproductive planning, and early diagnosis.'
  },
  'Surrogacy & Egg Donation Services': {
    title: 'Surrogacy & Egg Donation Services',
    description: 'Ethical and legally compliant surrogacy and egg donation programs offering support to intended parents through every step of the journey.'
  },
  'Hematology': {
    title: 'Hematology',
    description: 'Diagnosis and treatment of blood disorders including anemia, leukemia, lymphoma, and clotting abnormalities with advanced therapies.'
  },
  'Radioactive Iodine Therapy (RAI)': {
    title: 'Radioactive Iodine Therapy (RAI)',
    description: 'Targeted treatment for thyroid disorders using radioactive iodine, commonly used in hyperthyroidism and thyroid cancer management.'
  },
  'Nutrition & Dietetics': {
    title: 'Nutrition & Dietetics',
    description: 'Personalized nutritional assessment and dietary planning for disease management, wellness, and recovery support.'
  },
  'Neonatology': {
    title: 'Neonatology',
    description: 'Specialized care for newborns, particularly premature or critically ill babies, with advanced neonatal intensive care support.'
  },
  'Endocrinology': {
    title: 'Endocrinology',
    description: 'Comprehensive management of hormonal disorders including diabetes, thyroid diseases, and metabolic dysfunctions.'
  },
  'Computer Vision Syndrome (CVS)': {
    title: 'Computer Vision Syndrome (CVS)',
    description: 'Diagnosis and treatment of eye strain and discomfort caused by prolonged screen use, with personalized visual and ergonomic solutions.'
  },
  'SMILE Laser Eye Surgery': {
    title: 'SMILE Laser Eye Surgery',
    description: 'Minimally invasive laser vision correction procedure offering faster recovery, improved comfort, and high precision outcomes.'
  },
  'Pediatric Ophthalmology': {
    title: 'Pediatric Ophthalmology',
    description: 'Specialized eye care for children including vision screenings, treatment for lazy eye, and pediatric cataract surgery.'
  },
    'Sleeve Gastrectomy Surgery': {
    title: 'Sleeve Gastrectomy Surgery',
    description: 'Minimally invasive bariatric procedure that removes a portion of the stomach to promote weight loss and improve metabolic health.'
  },
  'Bilateral Total Knee Replacement Surgery': {
    title: 'Bilateral Total Knee Replacement Surgery',
    description: 'Simultaneous replacement of both knees to relieve pain and restore mobility in patients with severe knee joint degeneration.'
  },
  'Unilateral Total Knee Replacement Surgery': {
    title: 'Unilateral Total Knee Replacement Surgery',
    description: 'Surgical replacement of a single damaged knee joint with a prosthetic implant to restore function and reduce pain.'
  },
  'Coronary Angioplasty with One Stent': {
    title: 'Coronary Angioplasty with One Stent',
    description: 'Minimally invasive procedure to open blocked coronary arteries using a stent, improving blood flow and heart function.'
  },
  'Coronary Artery Bypass Grafting (CABG) Surgery': {
    title: 'Coronary Artery Bypass Grafting (CABG) Surgery',
    description: 'Major cardiac surgery that improves blood flow to the heart by creating new routes around blocked coronary arteries.'
  },
  'Aortic/ Mitral Valve Replacement (AVR/MVR) with Metallic Valve': {
    title: 'Aortic/ Mitral Valve Replacement (AVR/MVR) with Metallic Valve',
    description: 'Surgical replacement of diseased heart valves with durable metallic valves to restore proper heart function.'
  },
  'PCOS': {
    title: 'PCOS',
    description: 'Comprehensive diagnosis and management of Polycystic Ovary Syndrome, focusing on hormonal balance and reproductive health.'
  },
  'Erectile dysfunction (ED)': {
    title: 'Erectile dysfunction (ED)',
    description: 'Advanced evaluation and treatment for erectile dysfunction, including medical and lifestyle interventions for male sexual health.'
  },
  'Cancer and Infertility': {
    title: 'Cancer and Infertility',
    description: 'Specialized care addressing fertility challenges in cancer patients with fertility preservation and reproductive support.'
  },
  'Female Infertility': {
    title: 'Female Infertility',
    description: 'Expert evaluation and treatment of female infertility, including ovulation induction, IUI, IVF, and hormonal therapies.'
  },
  'Male Infertility': {
    title: 'Male Infertility',
    description: 'Comprehensive diagnosis and treatment for male reproductive health including sperm analysis, ICSI, and hormonal management.'
  },
  'Fertility Preservation': {
    title: 'Fertility Preservation',
    description: 'Advanced services to preserve reproductive potential through egg, sperm, or embryo freezing for future family planning.'
  },
  'Recurrent Pregnancy Loss': {
    title: 'Recurrent Pregnancy Loss',
    description: 'Specialized care for repeated miscarriages with in-depth diagnosis and customized treatment to improve pregnancy outcomes.'
  },
  'Endometriosis Management': {
    title: 'Endometriosis Management',
    description: 'Multidisciplinary approach to diagnose and treat endometriosis, focusing on pain relief and fertility preservation.'
  },
  'Fetal Medicine and Prenatal Care': {
    title: 'Fetal Medicine and Prenatal Care',
    description: 'Advanced prenatal services including fetal anomaly scans, genetic testing, and high-risk pregnancy monitoring.'
  },
  'Hormonal Imbalance Treatment': {
    title: 'Hormonal Imbalance Treatment',
    description: 'Comprehensive evaluation and treatment for hormonal disorders affecting metabolism, reproduction, and general health.'
  },
  'Bariatric Surgery': {
    title: 'Bariatric Surgery',
    description: 'Weight loss surgery options including sleeve gastrectomy and gastric bypass for obesity and related metabolic conditions.'
  },
  'Neuro-Radiology': {
    title: 'Neuro-Radiology',
    description: 'Advanced imaging and interventional procedures for diagnosing and treating disorders of the brain, spine, and nervous system.'
  },
  'Bone Marrow Transplant': {
    title: 'Bone Marrow Transplant',
    description: 'Life-saving treatment for blood cancers and disorders using stem cell or bone marrow transplantation from matched donors.'
  },
  'Medical and Radiation Oncology service': {
    title: 'Medical and Radiation Oncology service',
    description: 'Comprehensive cancer care combining chemotherapy, targeted therapy, and advanced radiation treatments.'
  },
  'Algology': {
    title: 'Algology',
    description: 'Specialized pain management services using medication, interventional procedures, and rehabilitation techniques.'
  },
  'Gynecologic Oncology': {
    title: 'Gynecologic Oncology',
    description: 'Specialized cancer care for women including ovarian, uterine, cervical, and vulvar cancer treatment.'
  },
  'Gastrointestinal Oncology Unit': {
    title: 'Gastrointestinal Oncology Unit',
    description: 'Focused cancer treatment for the digestive tract including stomach, colon, liver, and pancreatic cancers.'
  },
  'Hemorrhoid and Anorectal Diseases': {
    title: 'Hemorrhoid and Anorectal Diseases',
    description: 'Comprehensive diagnosis and treatment of anorectal conditions including piles, fissures, fistulas, and abscesses.'
  },
  'Liver Transplant Center': {
    title: 'Liver Transplant Center',
    description: 'State-of-the-art facility offering comprehensive liver transplant services for end-stage liver disease and liver failure.'
  },
  'Orthopedic Oncology': {
    title: 'Orthopedic Oncology',
    description: 'Specialized care for bone and soft tissue cancers with advanced surgical and non-surgical treatment approaches.'
  }

};

// Function to get speciality data by name
export const getSpecialityData = (specialityName) => {
  return specialitiesData[specialityName] || {
    title: specialityName,
    description: `Expert care and treatment services in ${specialityName} with modern facilities and experienced medical professionals.`
  };
};

// Function to get multiple specialities data
export const getSpecialitiesData = (specialityNames) => {
  return specialityNames.map(name => getSpecialityData(name));
};
